export default [
    {
        path: '/promotion',
        name:'promotion',
        component:()=> import('@/views/pages/cloudx/promotion/promotion.vue')
    }
]
  